import { render, staticRenderFns } from "./AppointmentTypeIcon.vue?vue&type=template&id=0558e7f8"
import script from "./AppointmentTypeIcon.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports